import clsx from "clsx";
import { FC, ReactNode } from "react";

import { ExpandablePanel } from "@tsmono/react/components";
import { isRecord } from "@tsmono/util";

import { MetaDataGrid } from "../../content/MetaDataGrid";
import { RenderedText } from "../../content/RenderedText";

import styles from "./CompactionData.module.css";

export const kCompactionMetadata = "compaction_metadata";

export const CompactionData: FC<{
  id: string;
  data: Record<string, unknown>;
}> = ({ id, data }) => {
  // get the compaction metadata
  const raw = data[kCompactionMetadata];
  const compactionMetadata = isRecord(raw) ? raw : {};

  const compactionContent: ReactNode =
    compactionMetadata.type === "anthropic_compact" ? (
      <ExpandablePanel id={`${id}-compacted-content`} collapse={true}>
        <RenderedText markdown={String(compactionMetadata.content)} />
      </ExpandablePanel>
    ) : (
      <MetaDataGrid
        id={`${id}-compacted-content-metadata`}
        className={styles.grid}
        entries={compactionMetadata}
        options={{ copyButton: true }}
      />
    );

  return (
    <div className={clsx(styles.content, "text-size-small")}>
      <div
        className={clsx(
          "text-style-label",
          "text-style-secondary",
          styles.title
        )}
      >
        Compacted Content
      </div>
      {compactionContent}
    </div>
  );
};
